import React from 'react';
import { Navbar } from '../components/Navbar';
import { HeroSection } from '../components/HeroSection';
import { RaceInfo } from '../components/RaceInfo';
import { RacingClasses } from '../components/RacingClasses';
import { CompetitionMap } from '../components/CompetitionMap';
import { TeamSponsors } from '../components/TeamSponsors';
import { ContactForm } from '../components/ContactForm';
import { PhotoGallery } from '../components/PhotoGallery';
import { Footer } from '../components/Footer';
import { LanguageProvider } from '../context/LanguageContext';
export function HomePage() {
  return <LanguageProvider data-id="element-712">
      <div className="min-h-screen w-full bg-black" data-id="element-713">
        <Navbar data-id="element-714" />
        <main data-id="element-715">
          <HeroSection data-id="element-716" />
          <RaceInfo data-id="element-717" />
          <RacingClasses data-id="element-718" />
          <CompetitionMap data-id="element-719" />
          <TeamSponsors data-id="element-720" />
          <ContactForm data-id="element-721" />
          <PhotoGallery data-id="element-722" />
        </main>
        <Footer data-id="element-723" />
      </div>
    </LanguageProvider>;
}